import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import addLogDocument from "../addLogDocument"; // Assuming you have this utility for logging
import JSZip from "jszip"; // To handle zip file extraction
import { checkDB } from "../../models/DataFunctions";

const generatePDF = async (
  xmlUrl,
  listlots,
  type,
  oid,
  token,
  orgData,
  folderid,
  phone,
  email,
  address,
  name,
  prefix,
  new_model = false
) => {
  // Define the endpoint URL
  const url = prefix + `folders/${folderid}/xml/generate_pdf`;

  const fileResponse = await fetch(xmlUrl);
  if (!fileResponse.ok) {
    throw new Error(`Failed to download file: ${fileResponse.status}`);
  }

  const fileBytes = await fileResponse.arrayBuffer();
  const zip = await JSZip.loadAsync(fileBytes); // Load ZIP file
  let xmlContent = null;
  // Extract the first XML file from the ZIP
  for (const filename in zip.files) {
    if (filename.endsWith(".xml") && !filename.includes("/")) {
      xmlContent = await zip.file(filename).async("string");
      break;
    }
  }

  if (!xmlContent) {
    throw new Error("No XML file found in the ZIP archive");
  }

  const fileBlob = new Blob([xmlContent], { type: "application/xml" });
  const formData = new FormData();
  formData.append("file", fileBlob, "xml_to_generate.xml");
  // Define the request body
  const logo =
    orgData.config?.ath?.hide_my_logo === true
      ? null
      : orgData.logo || "https://i.ibb.co/8Nc2tS4/Placeholder.png";
  const body = {
    footer: `${name} - ${address}\nTéléphone : ${phone} - Mail : ${email}`,
    type: type,
    oid: oid,
    batch: listlots || [],
    logo: logo,
    new_model: new_model,
  };
  formData.append("request", JSON.stringify(body));

  try {
    let start = new Date();
    // Make the POST request using fetch
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error("User not logged in");
      return "";
    }

    const userRef = doc(getFirestore(), "user", currentUser.uid);
    const userDoc = await getDoc(checkDB(userRef));
    const org_id = userDoc.get("org_id");
    let end = new Date();
    let elapsed = end - start;
    const responseText = await response.text();
    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "",
      "",
      JSON.stringify(body),
      responseText,
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      const pdfData = JSON.parse(responseText);
      const url = pdfData.url.trim().replace(/"/g, "");
      const sign_coords = pdfData.sign_coords;

      return { url: url, sign_coords: sign_coords };
    } else {
      console.error(`Failed to send request: ${response.status}`);
      return "";
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default generatePDF;
